export const DEFAULT_SUFFIX = 'default';
export const VERSION_PREFIX = 'v';
